export const SLOW_NETWORK = "Your request is slow due to network conditions.";
export const NETWORK_RETRY = (attemptNumber: number) =>
  `Network issue detected. Retrying ... (Attempt ${attemptNumber})`;
export const NETWORK_FAILED = (totalAttempts: number) =>
  `Network failed after ${totalAttempts} tries. Please check your network.`;
export const UNEXPECTED_ERROR_OCCURRED = "An unexpected error occurred";
